<script lang="ts" setup>
	import { useMarketingStore } from '@/store/marketing.store';
	import { useModalStore } from '@/store/modal.store';
	import { ISignUpLink } from '@/types';
	import { computed, ref, watch } from 'vue';
	import { useRoute } from 'vue-router';
	import DefaultBtn from "@/components/block/DefaultBtn.vue";

  const props = defineProps<{
    closeSignal?: boolean
  }>();

  watch(() => props.closeSignal, () => {
    if (props.closeSignal) {
      close();
    }
  });

	const modalStore = useModalStore();
	const marketingStore = useMarketingStore();
	const route = useRoute();
	
	const linkId = computed<number>(() => +(route.params.linkId || '0') || 0);
	const originLink = computed<ISignUpLink | undefined>(() => linkId.value && marketingStore.signUpLinksMap.get(linkId.value) || undefined);

	const newLink = ref<ISignUpLink | undefined>(originLink.value && JSON.parse(JSON.stringify(originLink.value)));

	watch(() => originLink.value, () => {
		newLink.value = JSON.parse(JSON.stringify(originLink.value));
	});

	const loading = ref<boolean>(false);
	const renameLink = ():void => {
		if (newLink.value) {
			loading.value = true;
			marketingStore.renameSignUpLink(linkId.value, newLink.value.name || '-')
				.then(() => {
					modalStore.closeModal();
				})
				.finally(() => {
					loading.value = false;
				})
		}
	};

	const close = ():void => {
		if (!loading.value) {
			modalStore.closeModal();
		}
	};
</script>

<template>
	<div v-if="newLink" class="modal modal--active">
		<div class="modal__body">
			<div class="modal__header">
				<p class="modal__subtitle">
					<span class="material-symbols-outlined">link</span>
					<span>Rename Link</span>
				</p>
				<button @click="modalStore.closeModal" class="modal__close">
					<span class="material-symbols-outlined">close</span>
				</button>
			</div>
			<div class="modal__main" >
				<form @submit.prevent="renameLink">
					<p class="modal__title">Let’s give this link a new name</p>
					<div class="login__item">
						<input
							v-model="newLink.name"
							class="input"
							placeholder="Company Name*">
							<span class="material-symbols-outlined login__item_ico">link</span>
					</div>
					<DefaultBtn  class="login__btn" :loading text="Continue" type="submit" />
				</form>
			</div>
		</div>
	</div>
</template>

<style scoped>
.modal__title{
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 30px;
}

.login__btn{
	max-width: 160px;
	box-shadow:none;
}

</style>